import { Component, forwardRef, Input } from '@angular/core';

import {
  ToastBodyComponent,
  ToastCloseDirective,
  ToastComponent,
  } from '@coreui/angular';

@Component({
  selector: 'app-toast-sample',
  templateUrl: './danger-toast.html',
  styles: [
    `
      :host {
        display: block;
        overflow: hidden;
      }
    `
  ],
  providers: [{ provide: ToastComponent, useExisting: forwardRef(() => DangerToastComponent) }],
  standalone: true,
  imports: [ToastBodyComponent, ToastCloseDirective]
})
export class DangerToastComponent extends ToastComponent {
  constructor() {
    super();
  }

  @Input() closeButton = false;
  @Input() title = '';
  @Input() message = '';
  override ngOnInit(): void {

  }
}
